'use strict';

import React, { Component, Fragment } from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Button from '@material-ui/core/Button'

import AutoCompletedField from '@Pure/AutoCompletedField'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

import { isTrue } from '@root/utility'

const { app, qwest } = window;

export default class GlobalSearchResults extends Component
{
	state =
	{
		open: false,
		loading: false,
		can_compute: true,

		products: [],
		partners: [],

		form_data: { 'global-search': '' }
	};

	componentDidMount ()
	{
		const props = this.props, component = this, state = this.state;

		app.push(
		{
			event: 'open__GlobalSearchResults',
			cb: component.open
		});

		app.push(
		{
			event: 'close__GlobalSearchResults',
			cb: component.close
		});

		app.push(
		{
			event: 'escapeKeyEvent',
			cb: component.handleEscape
		});
	}

	componentWillUnmount ()
	{
		const props = this.props, component = this, state = this.state;

		app.delete(
		{
			event: 'open__GlobalSearchResults',
			cb: component.open
		});

		app.delete(
		{
			event: 'close__GlobalSearchResults',
			cb: component.close
		});

		app.delete(
		{
			event: 'escapeKeyEvent',
			cb: component.handleEscape
		});
	}

	componentDidUpdate (prev_props, prev_state)
	{
		const component = this, props = this.props, state = this.state;

		if (prev_props.open !== true && props.open === true)
		{
			document.getElementById('global-search')?.focus();
		}
	}

	handleEscape = ({ source }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.close();
	}

	reset = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (e)
		{
			e.preventDefault();

			app.emit('documentClick', component);
		}

		state.form_data['global-search'] = '';

		document.getElementById('global-search')?.focus();

		component.setState(
		{
			form_data: state.form_data
		});
	}

	handleChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		let value = e ? e.target.value : data.value;

		state.form_data['global-search'] = value;

		component.setState(
		{
			form_data: state.form_data,
			can_compute: value ? false : true
		});

	// Prevent to search each letter typed and wait a bit.
		if (component.computation)
		{
			window.clearTimeout(component.computation);
		}

		if (value)
		{
			component.computation = window
			.setTimeout(component.enableComputation, 320);
		}
	}

	enableComputation = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (!state.form_data['global-search']) return;

		component.setState(
		{
			can_compute: true,
			loading: true
		});

		if (component.request) component.request?.abort();

		const request = qwest.post('/global-search',
		{
			searched: state.form_data['global-search'],
			holidays_partners: document.location
			.pathname === '/accueil/catalogue-synergies'
		})
		.then(function (xhr, response)
		{
			if (component.request !== request) return;

			component.request = undefined;

			component.setState(
			{
				loading: false,

				products: response.products,

				partners: isTrue(app.state.session?.permissions?.access_partners)
				? response.partners
				: []
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error);

			component.setState({ loading: false });
		});

		component.request = request;
	}

	open = (data) =>
	{
		const props = this.props, component = this, state = this.state;

		component.setState(
		{
			open: true,
			products: data ? (data.products || []) : [],
			partners: data ? (data.partners || []) : []
		});
	}

	close = (e) =>
	{
		const props = this.props, component = this, state = this.state;

		component.request = undefined;

		component.setState(
		{
			open: false,
			loading: false,

			form_data: { 'global-search': '' }
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader"
				bemit={ ['big', 'white', 'bg-search'] }
				text="Recherche..."
			/>
		)
		: undefined;

		let searchbar, overlay, content;

		if (state.open === true)
		{
			const searched = state.form_data['global-search'];

			searchbar =
			(
				<div className="c-searchbar c-searchbar--search-results">

					<AutoCompletedField data={ [] } id="global-search"
						name="global-search"
						value={ searched }
						onChange={ component.handleChange }
						placeholder="Rechercher dans les produits et partenaires"
						alt_class="c-autocomplete--global-search"
						autoFocus
					/>

					<label htmlFor="global-search">
						<svg className="o-svg-icon o-svg-icon--search c-searchbar__icon">
							<use xlinkHref="/images/icons.svg#svg-icon-search"></use>
						</svg>
					</label>

					<Button onClick={ component.reset } title="effacer"
						className={ 'c-searchbar__reset' + (searched ? ' js-visible' : '') }>
						<div className="c-searchbar__reset-icon"></div>
					</Button>

				</div>
			);

			let products = state.products.map(renderProduct);

			let partners = state.partners.map(renderPartner);

			if (products.length > 0)
			{
				products =
				(
					<Fragment>
						<div className="o-content">
							<div className="global-search-title">Produits</div>
						</div>

						<div className="o-grid-4">
							{ products }
						</div>
					</Fragment>
				);
			}

			if (partners.length > 0)
			{
				partners =
				(
					<Fragment>
						<div className="o-content u-no-margins">
							<div className="global-search-title">
								{
									document.location
									.pathname === '/accueil/catalogue-synergies'
									? 'Séjours & vacances'
									: 'Partenaires'
								}
							</div>
						</div>

						<div className="o-grid-4">
							{ partners }
						</div>
					</Fragment>
				);
			}

			overlay =
			(
				<CSSTransition
					classNames="a-overlay-transition"
					appear={ true }
					enter={ true }
					exit={ true }
					timeout={{ enter: 240, exit: 320 }}>

					<div className="o-global-search__overlay"></div>

				</CSSTransition>
			);

			content =
			(
				<CSSTransition
					classNames="a-overlay-transition"
					appear={ true }
					enter={ true }
					exit={ true }
					timeout={{ enter: 320, exit: 320 }}>

					<div className="o-global-search__content">

						<div className="o-global-search__close"
							onClick={ component.close }>
							<div className="o-global-search__close-icon"></div>
						</div>

						{ searchbar }

						{ products }

						{ partners }

						{ loader }

					</div>

				</CSSTransition>
			);
		}

		var output =
		(
			<TransitionGroup className={ 'o-global-search' + state.open ?
				' o-global-search--open' : '' }>

				{ overlay }

				{ content }

			</TransitionGroup>
		);

		return output;

		function renderProduct (product)
		{
			let image = (product.images || [])[0];

			let link = '/accueil/catalogue/' + product.id;

			if (link === document.location.pathname) return null;

			link = getLink(link);

			if (image)
			{
				image =
				(
					<Image className="c-search-view-item__img" src={ image.url } />
				);
			}
			else
			{
				image = undefined;
			}

			let content =
			(
				<Fragment>
					{ image }

					<div className="c-search-view-item__content">
						<div className="c-search-view-item__title">
							{ product.name }
						</div>
					</div>

					{ link }
				</Fragment>
			);

			let output =
			(
				<div className="c-search-view-item c-search-view-item--global-search">

					{ content }

				</div>
			);

			return <div className="o-grid__item" key={ product.id }>{ output }</div>;

			function getLink (pathname)
			{
				let link =
				(
					<Link className="u-link-only" href={ pathname }></Link>
				);

				if (document.location.pathname.indexOf('/accueil/catalogue/') === 0)
				{
					link =
					(
						<a className="u-link-only" href={ pathname }></a>
					);
				}

				return link;
			}
		}

		function renderPartner (partner)
		{
			let image = (partner.logo || [])[0];

			let link = '/accueil/espace-partenaires/partenaires/' + partner.id;

			if (link === document.location.pathname) return null;

			link = getLink(link);

			if (image)
			{
				image =
				(
					<Image className="c-search-view-item__img" src={ image.url } />
				);
			}
			else
			{
				image = (partner.images || [])[0];

				if (image)
				{
					image =
					(
						<Image className="c-search-view-item__img" src={ image.url } />
					);
				}
			}

			image = image || undefined;

			let content =
			(
				<Fragment>
					{ image }

					<div className="c-search-view-item__content">
						<div className="c-search-view-item__title">
							{ partner.name }
						</div>
					</div>

					{ link }
				</Fragment>
			);

			let output =
			(
				<div className="c-search-view-item c-search-view-item--global-search">

					{ content }

				</div>
			);

			return <div className="o-grid__item" key={ partner.id }>{ output }</div>;

			function getLink (pathname)
			{
				let link =
				(
					<Link className="u-link-only" href={ pathname }></Link>
				);

				if (document.location.pathname.indexOf('/accueil/espace-partenaires/partenaires/') === 0)
				{
					link =
					(
						<a className="u-link-only" href={ pathname }></a>
					);
				}

				return link;
			}
		}
	}
}